exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagefade-enter-active[data-v-26d4aea8],.pagefade-leave-active[data-v-26d4aea8]{transition:all .05s linear}.pagefade-enter[data-v-26d4aea8],.pagefade-leave-to[data-v-26d4aea8]{opacity:0}iframe[data-v-26d4aea8]{width:100%;height:100%}.scorm-show[data-v-26d4aea8]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:11000}.scorm-show-close[data-v-26d4aea8]{position:fixed;top:50px;right:15px;background:url(/Content/dist/icon-close.png?5770202fecb1913aa90b351f127f1bba) 50% no-repeat;height:20px;width:20px;cursor:pointer;z-index:12000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26d4aea8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/components/ScormViewer.vue
// module id = 997
// module chunks = 1